import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

export const StaticPageContainer = styled.div<{ mode: 'light' | 'dark' }>`
  background-color: ${(props) =>
    props.mode === 'dark' ? '#121212' : color.light};
  overflow: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
`;
